export default __webpack_public_path__ + "static/content-2d613752bd45527c2b87c5053b911462.jpg";